import React, { Fragment, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import ModalHistorialCambiosComponent from '../ModalHistorialCambiosComponent';


function DatosGeneralesComponent(props) {

    const dispatch = useDispatch()
    const dataUser = useSelector(store => store.Usuario.user)

    let cliente = props?.cliente
    const [numerosocio, setNumeroSocio] = React.useState(props?.cliente?.numerosocio);
    const [nombrerazonsocial, setNombreRazonSocial] = React.useState(props?.cliente?.nombrerazonsocial?.toUpperCase())
    const [rfc, setRfc] = React.useState(cliente?.rfc?.toUpperCase())
    const [telefono, setTelefono] = React.useState(cliente?.telefono)
    const [correoelectronico, setCorreoElectronico] = React.useState(cliente?.correoelectronico)
    const [nombrerepresentantelegal, setNombreRepresentanteLegal] = React.useState(cliente?.nombrerepresentantelegal?.toUpperCase())
    const [telefonorepresentante, setTelefonoRepresentante] = React.useState(cliente?.telefonorepresentante)
    const [correoelectronicorepresentante, setCorreoElectronicoRepresentante] = React.useState(props?.cliente?.correoelectronicorepresentante)

    let [representante, setRepresentante] = React.useState(nombrerepresentantelegal == '' ? true : false)

    const [openModal, setOpenModal] = React.useState(false);
    const handleOpenModal = () => { setOpenModal(true) }
    const handleCloseModal = () => { setOpenModal(false) }

    const [openModalHistorial, setOpenModalHistorial] = React.useState(false);
    const [dataHistorial, setDataHistorial] = React.useState(cliente?.clientehistorial);
    const handleModalHistorial = () => {
        setDataHistorial(cliente?.clientehistorial)
        setOpenModalHistorial(true)
    }

    const obtenerCadenaActividades = (actividadcliente) => {
        const arregloCadena = actividadcliente?.map(item => item?.tipoactividad?.actividad || '');
        let combinacionCadena = '';
        if (arregloCadena.length == 1) {
            combinacionCadena = arregloCadena[0];
        } else if (arregloCadena.length > 1) {
            combinacionCadena = arregloCadena.slice(0, -1).join(', ') + ' y ' + arregloCadena.slice(-1);
        }
        return combinacionCadena;
    };

    return (
        <Fragment>
            <div className='row' style={{ marginLeft: 24, marginRight: 24 }}>
                    <div className='row' style={{ margin: 0, padding: 0 }}>
                        <div className="col-12 col-md-12 mt-0 mb-0 p-0 pe-4 text-end" >
                            <Tooltip title="Ver historial de cambios">
                                <IconButton size="large" sx={{ p: 1 }} onClick={() => { handleModalHistorial() }}>
                                    <HistoryRoundedIcon fontSize="inherit" sx={{ color: '#2B2B2B' }} />
                                </IconButton>
                            </Tooltip>
                        </div>
                        <div className="col-md-4 mt-3 ps-5 text-start"><label><b>Número de socio: <br /> </b> {numerosocio} </label> </div>
                        <div className="col-md-8 mt-3 ps-5 text-start"><label><b>Razón social: <br /> </b> {nombrerazonsocial} </label> </div>
                        <div className="col-md-4 mt-3 ps-5 text-start"><label><b>RFC: <br /> </b> {rfc} </label> </div>
                        <div className="col-md-4 mt-3 ps-5 text-start"><label><b>Teléfono: <br /> </b> {telefono} </label> </div>
                        <div className="col-md-4 mt-3 ps-5 text-start"><label><b>Correo electrónico: <br /> </b> {correoelectronico} </label> </div>
                        <div className="col-md-4 mt-3 ps-5 text-start"><label><b>Nombre representante legal: <br /> </b> {nombrerepresentantelegal == '' ? '---' : nombrerepresentantelegal} </label> </div>
                        <div className="col-md-4 mt-3 ps-5 text-start"><label><b>Teléfono representante: <br /> </b> {telefonorepresentante == '' ? '---' : telefonorepresentante} </label> </div>
                        <div className="col-md-4 mt-3 ps-5 text-start"><label><b>Correo representante: <br /> </b> {correoelectronicorepresentante == '' ? '---' : correoelectronicorepresentante} </label> </div>
                        <div className="col-md-12 mt-3 ps-5 text-start"><label><b>Cadena productiva: <br /> </b> {obtenerCadenaActividades(props?.data.actividadcliente)?.toUpperCase()} </label> </div>
                    </div>
            </div>
            {openModalHistorial && <ModalHistorialCambiosComponent setOpenModalHistorial={setOpenModalHistorial} dataHistorial={dataHistorial} apartado={"Datos generales"} />}
        </Fragment>
    )
}

export default DatosGeneralesComponent